export default __webpack_public_path__ + "static/media/ic_corsica.f2e1ed63.svg";